import React from 'react';
import '../css/LogoutConfirmation.css';

const LogoutConfirmation = ({ onConfirm, onCancel }) => {
    return (
        <div className="logout-modal-overlay">
            <div className="logout-modal">
                <h2 className="logout-modal-title">Confirm Logout</h2>
                <p className="logout-modal-message">Are you sure you want to log out?</p>
                <div className="logout-modal-buttons">
                    <button className="logout-modal-button cancel" onClick={onCancel}>
                        Cancel
                    </button>
                    <button className="logout-modal-button confirm" onClick={onConfirm}>
                        Logout
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LogoutConfirmation;
